enum UserContentTypes {
  DateChangeRequests = 'dateChangeRequests',
  Tasks = 'tasks',
  LeadNotifications = 'leadNotifications',
  LeadAssignedNotification = 'leadAssignedNotification',
}

export default UserContentTypes;
